import React from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Container,
    useTheme,
} from "@mui/material";
import { motion } from "framer-motion";


const articles = [
    {
        title: "Customer First Approach.",
        desc: "Thousands of users trust us for managing their finances securely....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/trusted",
    },
    {
        title: "24x7 Support",
        desc: "Dedicated customer support round the clock for your needs....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/24*7",
    },
    {
        title: "Secure & Reliable",
        desc: "We ensure data privacy and use bank-level encryption....",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/secure",
    },
];

const WhyUs = () => {
    const theme = useTheme();
    const MotionBox = motion(Box);

    return (
        <Box sx={{ py: { xs: 5, md: 4 } }}>
            <Container maxWidth="lg">

                {/* HEADER */}
                <Box sx={{ mb: { xs: 3, md: 4 } }}>
                    <Typography
                        sx={{
                            fontSize: "13px",
                            letterSpacing: "1.5px",
                            fontWeight: 600,
                            mb: 1,
                            color: theme.palette.primary.main,
                        }}
                        data-aos="fade-right"
                    >
                        • OUR EDGE
                    </Typography>


                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        Why Government Employees Trust{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            ArthGyan
                        </Box>{" "}
                        {/* Different

                         ArthGyan */}
                    </Typography>





                </Box>


                <MotionBox
                    initial={{ y: 80, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "1fr 1fr",
                            md: "1fr 1fr 1fr",
                        },
                        gap: { xs: 2.5, md: 3 },
                    }}
                >
                    {articles.map((item, index) => (
                        <Card
                            key={index}
                            elevation={0}
                            sx={{
                                borderRadius: "18px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #e6edf5",
                                boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
                                transition: "all 0.3s ease",
                                overflow: "hidden",
                                cursor: "pointer",

                                "&:hover": {
                                    transform: "translateY(-6px)",
                                    boxShadow: `0 20px 40px ${theme.palette.primary.main}20`,
                                },
                            }}
                        >
                            {/* IMAGE WRAPPER */}
                            <Box
                                sx={{
                                    p: 1,
                                    pb: 0,
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.img}
                                    alt={item.title}
                                    sx={{
                                        width: "100%",
                                        height: { xs: 180, md: 200 },
                                        objectFit: "cover",
                                        borderRadius: "12px",
                                        transition: "transform 0.4s ease",
                                        "&:hover": {
                                            transform: "scale(1.08)",
                                        },
                                    }}
                                />
                            </Box>

                            <CardContent sx={{ p: 2.5 }}>
                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 600,
                                        mb: 0.5,
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "13px",
                                        color: theme.palette.text.secondary,
                                    }}
                                    data-aos="fade-up"

                                >
                                    {item.desc}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </MotionBox>

            </Container>
        </Box>
    );


};

export default WhyUs;
